/**
 * Canonical href format for in-app file links. Used by:
 *   - the `remarkWikiLinks` plugin, to turn `[[Target]]` into a markdown link;
 *   - `<AgentMarkdown>`'s `<a>` override, to detect those links and hand them to
 *     the host's router;
 *   - the markdown editor's wiki-link extension (via the consumer-supplied
 *     `wikiLinkHref` / `parseWikiLinkHref` props on `MarkdownEditor`) so stored
 *     `[[Target]]` round-trips through a real `<a href>` rather than a custom
 *     `wiki:` scheme.
 *
 * Path separators are kept literal (not percent-encoded) so the URL still reads
 * as a nested path.
 */

export const FILES_PREFIX = "/files/";

export function buildFileHref(target: string): string {
  const encoded = encodeURIComponent(target).replace(/%2F/gi, "/");
  return `${FILES_PREFIX}${encoded}`;
}

export function parseFileHref(href: string | null | undefined): string | null {
  if (typeof href !== "string" || !href.startsWith(FILES_PREFIX)) return null;
  const raw = href.slice(FILES_PREFIX.length);
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}
